<template>
  <v-dialog
    v-model="bugReportDialog"
    width="500px"
  >
    <v-card>
      <v-toolbar
        dark
        color="secondary"
        flat
      >
        <v-btn
          icon
          dark
          @click.native="bugReportDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>דיווח על התקלה</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary darken-2"
          depressed
          large
          :loading="sending"
          :disabled="sending"
          @click="send"
        >
          שליחה
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-textarea
          name="message"
          label="תיאור התקלה"
          value=""
          v-model="message"
          rows="15"
          hint="כדאי לפרט: מה קרה? מה היה אמור לקרות? דברים מוזרים אחרים..."
        ></v-textarea>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getApi } from "@/api";

export default {
  data() {
    return {
      sending: false,
      message: ""
    };
  },

  computed: {
    bugReportDialog: {
      get() {
        return this.$store.getters["bugReport/bugReportDialog"];
      },
      set(isActive) {
        this.$store.dispatch("bugReport/TOGGLE_BUG_REPORT_DIALOG", isActive);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    }
  },

  methods: {
    send() {
      this.sending = true;

      getApi()
        .then(api => {
          let params = {
            text: `${this.message}\n\nדווח ע״י: ${this.user.name || "ללא שם"}`
          };
          return api.post("bug-reports", params);
        })
        .then(() => {
          this.bugReportDialog = false;
          this.message = "";
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: "ההודעה נשלחה. תודה על הדיווח!",
            color: "success"
          });
        })
        .catch(err => {
          console.log(err);
          this.$store.dispatch("SHOW_SNACKBAR", {
            text: err.message,
            color: "error"
          });
        })
        .finally(() => {
          this.sending = false;
        });

      setTimeout(() => {
        this.sending = false;
      }, 1000);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
